import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Bundled so the guide always opens (no dependency on static file or Amplify redirects)
import guideHtml from '../assets/guide.html?raw';

export default function Guide() {
  const { t, i18n } = useTranslation();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 80px)', minHeight: 400 }}>
      <div style={{ padding: '0.5rem 1rem', background: '#f0fdfa', borderBottom: '1px solid #99f6e4', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem' }}>
        <span style={{ fontWeight: 600, color: '#0f766e' }}>{t('dashboard.inboxTitle')} — User guide</span>
        <Link to="/" style={{ color: '#0d9488', fontWeight: 600, textDecoration: 'none' }}>← Back to site</Link>
      </div>
      <iframe
        title={i18n?.language === 'ar' ? 'دليل المستخدم' : 'User guide'}
        srcDoc={typeof guideHtml === 'string' ? guideHtml : ''}
        style={{ flex: 1, width: '100%', border: 'none', minHeight: 500 }}
        sandbox="allow-same-origin"
      />
    </div>
  );
}
